import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DeviceDetectorService } from 'ngx-device-detector';
import { TimeCardService } from 'projects/app-misc/src/app/modules/punch-time-widget/data/time-card.service';
import { AppStateQuery } from '../../../data/app-state.query';
import { TimeCardsQuery } from 'projects/app-misc/src/app/modules/punch-time-widget/data/time-cards.query';
import { takeUntilDestroyed } from 'projects/core/src/public-api';
import { filter, take, debounceTime } from 'rxjs/operators';
import { interval, Subject } from 'rxjs';
import moment from 'moment';
import { PunchWidgetDialogComponent } from 'projects/app-misc/src/app/modules/punch-time-widget/view/punch-widget-dialog/punch-widget-dialog.component';
import { WsService } from 'projects/app-misc/src/app/modules/data/ws.service';
import { WsUpdateResponce } from 'projects/app-misc/src/app/modules/data/ws-update-responce';
import { User } from 'projects/core/src/lib/login/data/user';
import { TimeCardsStore } from 'projects/app-misc/src/app/modules/punch-time-widget/data/time-cards.store';
import { takeUntil } from 'rxjs/operators';
import { RxJSUnsubscribe } from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import { RxJSUnsubscribable } from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';

@Component({
    selector: 'app-system-clock',
    templateUrl: './system-clock.component.html',
    styleUrls: ['./system-clock.component.scss']
})
@RxJSUnsubscribe
export class SystemClockComponent implements OnInit, OnDestroy, RxJSUnsubscribable {

    punchedIn$ = this.timeCardsQuery.punchedIn$;
    punchStatus: boolean;

    trackWorkTime$ = this.timeCardsQuery.trackWorkTime
    currentUser$ = this.appStateQuery.currentUser$

    breakType: string;

    totalTime: string;

    userId: number;


    constructor(
        private dialog: MatDialog,
        private timeCardService: TimeCardService,
        protected appStateQuery: AppStateQuery,
        protected timeCardsQuery: TimeCardsQuery,
        protected timeCardsStore: TimeCardsStore,
        protected wsService: WsService
    ) { }


    ngOnInit() {
        this.punchedIn$
            .pipe(
                takeUntil(this.getUnsubFromAllSubs())
            )
            .subscribe(status => {
                this.punchStatus = status;
            })


        this.trackWorkTime$
            .pipe(
                takeUntil(this.getUnsubFromAllSubs()),
                filter(trackWorkTime => trackWorkTime),
                take(1)
            )
            .subscribe(status => {
                this.onWorkTimeTrackNeeded()
            })


        this.currentUser$.subscribe(user => {
            this.userId = user.id;
            if (user.trackWorkTime) {

                this.getTodayTotalTime();
                this.getWeekTotalTime();

                interval(30000)
                    .pipe(
                        takeUntil(this.getUnsubFromAllSubs())
                    )
                    .subscribe(emit => {

                        if (this.punchStatus) {
                            this.getTodayTotalTime();
                            this.getWeekTotalTime();
                        }

                    })

                this.timeCardsQuery.todayTotalTime$.subscribe(time => {
                    const totalHours = Math.trunc(time / 60)
                    const totalMinutes = Math.trunc(time - totalHours * 60)
                    this.totalTime = totalHours + 'h ' + totalMinutes + 'm'
                })

            }
        })

        this.timeCardsQuery.breakType$.subscribe(type => {
            this.breakType = type;
        })
    }

    getTodayTotalTime() {
        const today = moment().format('YYYY-MM-DD')
        this.timeCardService.getTodayTotalTime(this.userId, today, today).subscribe(time => { })
    }

    getWeekTotalTime() {
        const startWeek = moment().startOf('week').format('YYYY-MM-DD');
        const endWeek = moment().endOf('week').format('YYYY-MM-DD');

        this.timeCardService.getWeekTotalTime(this.userId, startWeek, endWeek).subscribe(time => {
        })
    }

    onWorkTimeTrackNeeded(): void {
        this.timeCardService.getTodayCards().subscribe();
    }

    openPunchWidget() {
        const dialogRef = this.dialog.open(PunchWidgetDialogComponent, {
            disableClose: false,
            panelClass: 'punch-widget-dialog'
        });

        dialogRef.afterClosed().subscribe(result => {
        });

    }

    ngOnDestroy() {

    }

    getUnsubFromAllSubs(): Subject<boolean> {
        return null
    }

}
